(function() {
  const mediaSelector = 'hdt-product-media[can-has-media-group]';
  const imageSelector = '.hdt-product-media__main [data-media-type="image"] img';
  const firstVisibleImageSelector = '.hdt-product-media__main [data-media-type="image"]:not([hidden]) img';
  const initializedMedia = new WeakSet();

  const prioritizeVisibleGroup = (media) => {
    media.querySelectorAll(imageSelector).forEach((image) => {
      image.setAttribute('loading', 'lazy');
      image.setAttribute('fetchpriority', 'low');
    });

    const firstVisibleImage = media.querySelector(firstVisibleImageSelector);
    if (!firstVisibleImage) {
      return;
    }

    firstVisibleImage.setAttribute('loading', 'eager');
    firstVisibleImage.setAttribute('fetchpriority', 'high');
  };

  const initialize = (root) => {
    root.querySelectorAll(mediaSelector).forEach((media) => {
      if (initializedMedia.has(media)) {
        return;
      }

      const formId = media.getAttribute('form');
      const form = formId ? document.getElementById(formId) : null;
      if (!form) {
        return;
      }

      form.addEventListener('variant:change', () => {
        queueMicrotask(() => prioritizeVisibleGroup(media));
      });
      initializedMedia.add(media);
    });
  };

  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
